import { render } from "./Account.vue?vue&type=template&id=1b5b7a32"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=1b5b7a32&lang=css"
script.render = render

export default script